import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/aih`

    const headers = { responseType: "arraybuffer" }

    return {
        laudo(internacaoId) {

            return repository.get(`${baseUrl}/${internacaoId}/laudo`, headers)
        },
        termoResponsabilidade(internacaoId) {

            return repository.get(`${baseUrl}/${internacaoId}/termo-responsabilidade`, headers)
        },
    }
}
